import { ColumnDef, DataGrid } from '@if/mui'
import { Metro2Reporting } from '@src/types/loan/loan-calendar'
import { CircleCheck, Clock } from 'lucide-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Metro2ReportingHistoryTableProps {
  reportings: Metro2Reporting[]
}

/** Every reporting the loan has carried, newest first. */
const Metro2ReportingHistoryTable = ({ reportings }: Metro2ReportingHistoryTableProps) => {
  const { t } = useTranslation()

  const rows = useMemo(
    () => [...reportings].sort((a, b) => b.createdOn.getTime() - a.createdOn.getTime()),
    [reportings],
  )

  const columns = useMemo<ColumnDef<Metro2Reporting>[]>(
    () => [
      {
        name: 'metro2OverrideDate',
        type: 'dateonly',
        header: t('loan.payment.creditReportDialog.date'),
        width: 140,
      },
      {
        name: 'reason',
        header: t('loan.payment.creditReportDialog.reason'),
        getValue: (row) => t(`enum.EMetro2ReportingReason.${row.metro2ReportingReason}`),
        minWidth: 160,
      },
      {
        name: 'description',
        header: t('loan.payment.creditReportDialog.desc'),
        minWidth: 200,
        flexGrow: 1,
        wrap: true,
      },
      {
        name: 'createdByUserFullname',
        header: t('loan.payment.creditReportDialog.createdBy'),
        emptyPlaceholder: t('loan.payment.creditReportDialog.system'),
        minWidth: 160,
      },
      {
        name: 'createdOn',
        type: 'date',
        header: t('loan.payment.creditReportDialog.createdOn'),
        width: 160,
      },
      {
        name: 'reportedState',
        type: 'action',
        actions: [
          {
            icon: CircleCheck,
            label: t('loan.payment.creditReportDialog.reported'),
            palette: () => 'success',
            hidden: (row) => !row.reported,
          },
          {
            icon: Clock,
            label: t('loan.payment.creditReportDialog.notReported'),
            hidden: (row) => row.reported,
          },
        ],
      },
    ],
    [t],
  )

  return <DataGrid rows={rows} columns={columns} paginated={false} dense headerSticky square />
}

export default Metro2ReportingHistoryTable
